const getLoadingStatus = state => state.Regions.isLoading;
const getTerytData = state => state.Regions.terytData;
const getFormCompleted = state => state.Regions.formCompleted;

export {
  getLoadingStatus,
  getTerytData,
  getFormCompleted
}
